package com.essntl.features.crm.ui.contactorganization

import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.ViewModel
import com.essntl.core.utils.viewmodel.getData
import com.essntl.features.crm.domain.repository.CRMRepository
import com.essntl.toastmanager.ToastManager
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow

class ContactOrganizationViewModel(
    private val state: MutableStateFlow<ContactOrganizationState>,
    private val toastManager: ToastManager,
    private val crmRepository: CRMRepository,
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
) : ViewModel {

    fun onEvent(event: ContactOrganizationEvent) {
        when (event) {
            is ContactOrganizationEvent.Submit -> createContactOrganization(event)
            is ContactOrganizationEvent.ClearState -> clearState()
        }
    }

    private fun createContactOrganization(event: ContactOrganizationEvent.Submit) =
        getData(
            getData = {
                crmRepository.createContactOrganization(
                    organization = event.organization,
                    organizationAddress = event.organizationAddress,
                    contact = event.contact,
                    contactAddress = event.contactAddress,
                    customFields = if (event.customFields.isEmpty)
                        null else
                        event.customFields,
                )
            },
            getState = { state.value.addContactOrganization },
            setState = { state.value = state.value.copy(addContactOrganization = it) },
            onSuccess = {
                toastManager.success(
                    description = "Contact Organization created successfully",
                )
            },
        )

    private fun clearState() {
        state.value = ContactOrganizationState()
    }
}